"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giovanni-di-fassa": {
    "095884d4": [{
      "hkey": "4e415a9c",
      "slug": "san-giovanni-di-fassa",
      "name": "San Giovanni di Fassa",
      "primary": true,
      "skipSearch": false
    }],
    "meida": [{
      "hkey": "4e415a9c",
      "slug": "san-giovanni-di-fassa",
      "name": "San Giovanni di Fassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2103642b": [{
      "hkey": "16c6872c",
      "slug": "monzon-ronch",
      "name": "Monzon-Ronch",
      "primary": true,
      "skipSearch": false
    }],
    "monzon": [{
      "hkey": "16c6872c",
      "slug": "monzon-ronch",
      "name": "Monzon-Ronch",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d91e6677": [{
      "hkey": "1fe4bc0b",
      "slug": "pozza-di-fassa",
      "name": "Pozza di Fassa",
      "primary": true,
      "skipSearch": false
    }],
    "pozza": [{
      "hkey": "1fe4bc0b",
      "slug": "pozza-di-fassa",
      "name": "Pozza di Fassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-giovanni-di-fassa"
    }],
    "a33d6802": [{
      "hkey": "8918a329",
      "slug": "vigo-di-fassa",
      "name": "Vigo di Fassa",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "8918a329",
      "slug": "vigo-di-fassa",
      "name": "Vigo di Fassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-giovanni-di-fassa"
    }]
  }
};
exports["default"] = _default;